import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { KEY, SERVER } from './config';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';
// import ImageResize from 'image-resize';
import { help } from 'ionicons/icons';
import { HelperService } from './helper.service';
import { ShortCrypt } from 'short-crypt';


export interface User {
  id?: number;
  email: string;
  password?: string;
  name: string;
  role?: string;
  languagecode: string;
  language: string;
  birthyear: number;
  shirtNumber: number;
  profilepicture?: string;
  createdat?:string;
  updatedat?: string;


}
export interface Translate {
  id: string;
  language: string;
  reason: string[];
  sport: string[];
  trainingcategory: string[];
  physicality: string[];
  balltraining: string[];
  playerneed: string[];
  trainingfacility: string[];
  agerecomendation: string[];
  videomaker: string;
  code: string;
  language_en: string;
  skilllevel: string;
  physicallevel: string;
}
export interface Practice{
  id: number;
  videourl: string;
  title: string;
  sport: string[];
  trainingcategory: string[];
  physicality: string[];
  balltraining: string[];
  playerneed: string[];
  trainingfacility: string[];
  agerecomendation: string[];
  skilllevel: number;
  physicallevel: number;
  timeofcreation: String;
  updatedat: string;
  videomaker_id: string;
}
export interface videoMaker{
id: number;
name: string;
url: string;
createdat: string;

}
@Injectable({providedIn: 'root'})

export class RestService {
  myAngularxQrCode: any;
  sc: any;
  
  constructor(
    private http: HttpClient,
    private storage:StorageService,
    private helper:HelperService
 
  )
  { }
  
public async login(email: string, password: string): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {

  
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "email": email,
    "password": password
  });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow" as RequestRedirect
  };

  fetch(SERVER + "/user/login", requestOptions)
    .then((response) => response.text())
    .then((result:any) =>{ console.log('result: ',result)
    
    // this.storage.token = result.token;
    // this.storage.email = result.user.email;
    // this.storage.user = result.user;
    // this.storage.login = true;
    // this.storage.role = result.role;
    resolve(result);}
    )
    .catch((error) => console.error(error));
  });    
}

public async login2(email: string, password: string): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
  const body = {email:email, password:password };
  // const headers_ = new HttpHeaders();
  // headers_.append('Content-Type', 'application/json; charset=utf-8');
  // headers_.append('Access-Control-Allow-Origin' , '*');
  // headers_.append('Connection', 'keep-alive');
  // headers_.append('Keep-Alive', 'timeout=5');
  const headers = {'Content-Type': 'application/json'  };
  this.http.post<any>(SERVER + '/user/login', body, {headers: headers, responseType: 'json'})
  .subscribe({
      next: (result:any) => {
        // console.log('login2 result:', result);
        this.storage.token = result.token;
        this.storage.email = result.user.email;
        this.storage.user = result.user;
        this.storage.login = true;
        // this.storage.role = result.role;
        if(this.storage.role ==='admin'){
          this.storage.adminAvailable = true;
          console.log('adminAvailable: ', this.storage.adminAvailable);
        }
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
});
  
}

// public async login(email: string, password: string): Promise<number> {
//     return new Promise(async (resolve, reject) => {
        
//       let headers = new HttpHeaders();
//         headers.append('Content-Type', 'application/json');
//         console.log('login: ', email, ', password: ', password, ', headers: ', headers);
//         this.http.request('POST',SERVER + '/user/login', {
//             responseType:'json',
//             headers: headers,
//             body:{email: email,
//             password: password}
//         })
//             .subscribe({
//               next: (result:any) => {
//                 console.log('login result:', result, 'id: ', result.id);
//                 this.storage.token = result.access_token;
//                 console.log('token: ', this.storage.token);
//                 resolve(result);
//             }
//             , error: (error:any) => {
//                 reject(error);
//                 console.log('error: ', error);
//             }
//           });

//     });

// }

public async logout() {
  this.storage.token = '';
  this.storage.email = '';
  this.storage.user = '';
  this.storage.login = false;
  this.storage.role = '';
  this.storage.password = '';
  this.storage.page = '/app/login';
  this.storage.selectedUser = null;
  this.storage.age = 0;

}

public async checkUrl(url: string): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    
    this.http.get(url, )
    .subscribe({
        next: (result:any) => {
          // console.log('check Url ok result:', result);
          resolve(result);
        }
      ,error: (error:any) => {
        // console.log('check Url error: ', error);
        reject(error);
        // console.log('error: ', error);
      }
      });
  });
    
}

public async getMyUser(): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.get(SERVER + '/user/profile', {
      headers
    })
  .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      // console.log('error: ', error);
    }
  });
});


}

public async getUsers(): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.get(SERVER + '/user/users', {headers})
    .subscribe({
        next: (result:any) => {
          resolve(result);
        }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
      });
  });
    
}

public async updateUser(user: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = user;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.put(SERVER + '/user/update/'+user.id, body, {headers})
.subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
    
  });
}

public async deleteUser(id?: number):Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    if(id){
    this.http.delete(SERVER + '/user/'+id, {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
    ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
    }
    });
  }
  else{
    this.http.get(SERVER + '/user/delete', {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
    ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
    }
    });
  }
  });
}


public async createUser(user: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = user;
    const headers = {'Content-Type': 'application/json'};
    this.http.post(SERVER + '/user/signup', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
        this.storage.token = result.token;
        this.storage.email = result.user.email;
        this.storage.user = result.user;
        this.storage.login = true;
        this.storage.role = result.role;
      }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
  });
    
  });
}

 
public async getMyTranslateByCode(langCode:string): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json'};

    this.http.get<any>(SERVER + '/translate/mytranslate/'+langCode)
    .subscribe(result => {
      // console.log('result: ', result);
      // next: (result:any) => {
        resolve(result.translate);
      // }
      // ,error: (error:any) => {
      //   reject(error);
      //   // console.log('error: ', error);
      // }
  });
});
    
}
public async getTranslates(): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json'};//,'Authorization': 'Bearer ' + this.storage.token};
    this.http.get(SERVER + '/translate/translates', {headers})
    .subscribe({
      next: (result:any) => {
        //console.log('translates: ', result);
        resolve(result.data);
      }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
  });
});
    
}

public async updateTranslate(id:number,translate: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = translate;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.put(SERVER + '/translate/translate/'+id, body, {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
    
  });
}

public async deleteTranslate(id: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.delete(SERVER + '/translate/:'+id, {headers})
  .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
    
  });
}

public async createTranslate(translate: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = translate;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.post(SERVER + '/translate/translate', body, {headers})
.subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
    
  });
}

public async getVideos(): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {

    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.get(SERVER + '/practice/practices', {headers})
      .subscribe({
        next: (videos:any) => {
          // console.log('videos: ', result.data);
          // this.storage.practiceVideos = result.data;
          resolve(videos);
        }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
      });
  });
}

public async saveVideo(video: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = video;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.post(SERVER + '/practice/practice', body, {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
  });
}

public async updateVideo(id:number,video: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = video;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.put(SERVER + '/practice/practice/'+id, body, {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
    
  });
}

public async deleteVideo(id: number): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.delete(SERVER + '/practice/practice/'+id, {headers})
    .subscribe({
      next: (result:any) => {
        resolve(result);
    }
    ,error: (error:any) => {
      reject(error);
      // console.log('error: ', error);
    }
    });
    
  });
}
public async forgotPassword(email: string): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = {email};
    const headers = {'Content-Type': 'application/json'};
    this.http.put(SERVER + '/user/forgot', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
  });
    
  });
}
public async changePasswWcode(body: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    // console.log('body: ', body);
    const headers = {'Content-Type': 'application/json'};
    this.http.put(SERVER + '/user/changepass', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
        this.storage.token = result.token;
        this.storage.email = result.user.email;
        this.storage.user = result.user;
        this.storage.login = true;
        this.storage.role = result.role;
      }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
  });
    
  });
}
public async getVideoMakers(): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
        this.http.get(SERVER + '/videomaker/videomakers', {headers})
    .subscribe({
        next: (videomakers:any) => {
          // console.log('videosMakers: ', videomakers);
          resolve(videomakers);
        }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
      });
  });
}

public async saveVideoMaker(videoMaker: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = videoMaker;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.post(SERVER + '/videomaker/videomaker', body, {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    console.log('error: ', error);
  }
  });
  });
}

public async updateVideoMaker(id:number,videomaker: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
 
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.put(SERVER + '/videomaker/videomaker/'+ id, videomaker, {headers})
    .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    console.log('error: ', error);
  }
  });
    
  });
}

public async deleteVideoMaker(id: number): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.delete(SERVER + '/videomaker/videomaker/'+ id, {headers})
  .subscribe({
    next: (result:any) => {
      resolve(result);
    }
  ,error: (error:any) => {
    reject(error);
    // console.log('error: ', error);
  }
  });
    
  });
}
public async uploadPicture(image: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    // let formData:any = {'image':image}; 
    this.helper.startSpiner('Uploading picture');
    let image_:any;
    console.log('rest - image: ', image, 'image.blob.size: ', image.blob.size);
    // if (image && image.blob.size > 200000) {//(image.files[0] && image.files[0].size > 200000) {
    //   console.log('File size is greater than 200kB');
      
    //     let imageResize = await ImageResize({
    //      format: 'png',
    //      width: 400,
    //      quality: 0.7,
    //      outputType:'blob'
    //     });
    //     image_ = await imageResize.play(image.files[0]);
    //     console.log('resized image: ', image_);
    //     image_ = image;
        

    // }
    // else{
    //   console.log('File size is less than 200kB');
      image_ = image;
    // }
    let formData = new FormData();
    // if(image_ && image_.blob){

    // image_ = new File(image_.blob, image_.name, {
    //     type: image_.mimeType,
    //   });
    // }
    formData.append('image', image_.blob);
    // console.log('formData: ', formData);
    const headers = {
      // 'Accept': '*/*',
      // 'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer ' + this.storage.token};
      console.log('formData: ', formData,
      'headers: ', headers);
      // console.log('image_: ', image_);
    this.http.post(SERVER + '/user/uploadpic', formData, {headers})
    .subscribe({
      next: (result:any) => {
        resolve(result);
        this.helper.clearSpinners();
      }
      ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
      this.helper.clearSpinners();
      }
    });
    
  });
}
// resizeImage(file:any) {
//   let canvas = document.createElement('canvas');
//   let context = canvas.getContext('2d');
//   let maxW = 400;
//   let maxH = 400;
//   let img = document.createElement('img');

//   img.onload = function() {
//     let iw = img.width;
//     let ih = img.height;
//     let scale = Math.min((maxW / iw), (maxH / ih));
//     let iwScaled = iw * scale;
//     let ihScaled = ih * scale;
//     canvas.width = iwScaled;
//     canvas.height = ihScaled;
//     if(context)context.drawImage(img, 0, 0, iwScaled, ihScaled);
//     console.log(canvas.toDataURL());
//     document.body.innerHTML+=canvas.toDataURL();
//   }
//   img.src = URL.createObjectURL(file);
// }

// resizeImage_(file:File, maxWidth:number, maxHeight:number):Promise<Blob> {
//   return new Promise(async(resolve, reject) => {
//       let image = new Image();
//       image.src = URL.createObjectURL(file);
//       try {
//           let width = image.width;
//           let height = image.height;
          
//           if (width <= maxWidth && height <= maxHeight) {
//               resolve(file);
//           }

//           let newWidth;
//           let newHeight;

//           if (width > height) {
//               newHeight = height * (maxWidth / width);
//               newWidth = maxWidth;
//           } else {
//               newWidth = width * (maxHeight / height);
//               newHeight = maxHeight;
//           }

//           let canvas = document.createElement('canvas');
//           canvas.width = newWidth;
//           canvas.height = newHeight;

//           let context:any = canvas.getContext('2d');

//           context.drawImage(image, 0, 0, newWidth, newHeight);

//           (canvas.toBlob(context,file.type));
//       } catch{
//       image.onerror = reject;
//       }  
//     });
// }
  public async addPlayer2team(obj:{email?: string, key?: string, team_id:number}): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      let userToJoinTeam:any = {};
      if(obj.key && obj.team_id){         
          this.sc= new ShortCrypt(KEY);
          console.log('key: ', obj.key, 'team_id: ', obj.team_id, 'sc: ', this.sc);
          const decoder = new TextDecoder();
          userToJoinTeam = JSON.parse(decoder.decode(this.sc.decryptQRCodeAlphanumeric(obj.key)));
      }
      else if(obj.email && obj.team_id){
          userToJoinTeam = {email: obj.email};
      }
      else{
        reject('Missing key or team_id');
        return;
      }
          userToJoinTeam['team_id'] = obj.team_id;
          console.log('userToJoinTeam: ', userToJoinTeam);
          const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
          this.http.post(SERVER + '/team/player/email', userToJoinTeam, {headers})
            .subscribe({
            next: (result:any) => {
              resolve(result);
            }
            ,error: (error:any) => {
              reject(error);
              console.log('error: ', error);
              this.helper.toastMid('Error: '+error, 3000);
            }
          });  
    });
  }
  public async createTeamPlayer(teamPlayer: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/team/player/email', teamPlayer, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
      });
      
    });
  } 
  public async updateTeamPlayer(id:number,teamPlayer: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/player/'+ id, teamPlayer, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
  public async leaveTeam(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/leave/player/',  {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
    public async updateTeamTempPlayer(teamTempPlayer: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/tempplayer/'+ teamTempPlayer.id, teamTempPlayer, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
  public async removePlayerFromTeam(player_id:number ): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/team/player/'+player_id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }

    public async createTempPlayer(player: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/team/tempplayer', player, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }

  public async updateTempPlayer(id:number,player: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/tempplayer/'+ id, player, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }

    public async mergeTempPlayer2Player(tempPlayer: number, toPlayer: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      let body = {temp_player_id:tempPlayer, to_player_id: toPlayer};
      console.log('mergeTempPlayer2Player - body: ', body);
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/merge/player', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }

  public async removeTempPlayerFromTeam(player_id:number ): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/team/tempplayer/'+player_id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }

  public async getTeams(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/teams', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getTeamPlayers(team_id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/players/team' + team_id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async addCoach2team(obj:{team_id: number, email:string, user_id?:number, teamrole?:string}): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
     const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
     console.log('obj: ', obj); 
     this.http.post(SERVER + '/team/coach', obj, {headers})
        .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
          this.helper.toastMid('Error: '+error, 1000);
        }
      });
    });
  }
  public async removeCoachFromTeam(coach_id:number ): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/team/coach/'+coach_id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getMyTeamsInfo(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/user/myteams', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getTeamData(id:number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/data/' + id , {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async createNewTeam(team: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = team;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/team/team', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
    });
  }
  
  public async updateTeam(id:number,team: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/team/'+ id, team, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }

  public async getAllTeamChallenges(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/challenges/team/all', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getTeamChallenges(team_id:number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/challenges/team'+team_id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async setTeamChallenge(team_id:number,challengelist:any ): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/team/challenge/team/'+ team_id , challengelist, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
  public async delTeamChallenges(id:number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/team/team/challenge/'+id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }


  public async getClubTeams(id:number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/club/teams/'+id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }

  public async getClubs(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/team/clubs', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  
  public async uploadAnyPicture(image?: any,video?:boolean): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      let image_:any;
      if(video){
        this.helper.startSpiner(this.storage.translation.uploadingVideo_t || 'Uploading video');
        
      }
      else{
        this.helper.startSpiner(this.storage.translation.uploadingPic_t || 'Uploading picture');
              console.log('rest - image: ', image, 'image.blob.size: ', image.blob.size);
        if (image && image.blob.size > 200000) {
          console.log('File size is greater than 200kB');
            image_ = image;
        }
        else{
          console.log('File size is less than 200kB');
          image_ = image;
        }
      
      }
 
      let formData = new FormData();
      
      let path = '/team/uploadanyimage';
      if(video){
        path = '/user/uploadvideo';
        formData = this.storage.video2upload;
      }
      else{
        formData.append('image', image_.blob);
      }
      const headers = {
        'Authorization': 'Bearer ' + this.storage.token};
        console.log('formData: ', formData,
        'headers: ', headers);
        this.http.post(SERVER + path, formData, {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
            this.helper.clearSpinners();
            
          }
          ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
          this.helper.clearSpinners();
          }
        });
      
    });
  }
  public async sendVideoShareEmail(obj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      if(obj && obj.email && obj.url){ 
        const body = obj;
        console.log('sendVideoShareEmail body: ', body);
        this.http.post(SERVER + '/user/sendmessage',  body, {headers})
        .subscribe({
          next: (res:any) => {
            console.log('videoShare email sent: ', res);
            resolve(res);
          },
          error: (error:any) => {
            console.log('error sending message: ', error);
            reject(error);
          }
        });
      }
      else{
        reject('Invalid data');
      }
    });
  }

  public async createNewClub(club: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = club;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/team/club', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
    });
  }
  
  public async updateClub(id:number,club: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/team/club/'+ id, club, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
  
  public async deleteClub(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/team/club/'+ id, {headers})
    .subscribe({
      next: (result:any) => {
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      // console.log('error: ', error);
    }
    });
      
    });
  }
  public async getChallenges(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/practice/challenges', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async createNewChallenge(challenge: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/practice/challenge', challenge, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result.challenge);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
    });
  }
  
  public async updateChallenge(id:number,challenge: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/practice/challenge/'+ id, challenge, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result.challenge);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
  
  public async deleteChallenge(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/practice/challenge/'+ id, {headers})
    .subscribe({
      next: (result:any) => {
        resolve(result.challenge);
      }
    ,error: (error:any) => {
      reject(error);
      // console.log('error: ', error);
    }
    });
      
    });
  }
  public async getAllChallengesPractices(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/practice/challenge/practices', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getChallengePractices(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/practice/challenge/'+ id +'/practices' , {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async createNewChallengePractice(challengePractice: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = challengePractice;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/practice/challenge/practice', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result.challengepractice);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
    });
  }
  
  public async updateChallengePractice(id:number,challengePractice: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/practice/challenge/practice/'+ id, challengePractice, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result.challengepractice);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
      
    });
  }
  
  public async deleteChallengePractice(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/practice/challenge/practice/'+ id, {headers})
    .subscribe({
      next: (result:any) => {
        resolve(result.challengepractice);
      }
    ,error: (error:any) => {
      reject(error);
      // console.log('error: ', error);
    }
    });
      
    });
  }
  public async getChallengesResult(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/practice/challenge/results', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getTeamChallengesResult(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/practice/team/'+ id +'/challenge/results', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result.data);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async createNewChallengeResult(challengeResult: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = challengeResult;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/practice/challenge/result', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
      });
    });
  }
  
  public async updateChallengeResult(id:number,challengeResult: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/practice/challenge/result/'+ id, challengeResult, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
      });
      
    });
  }
  
  public async deleteChallengeResult(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/practice/challenge/result/'+ id, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
      ,error: (error:any) => {
        reject(error);
        // console.log('error: ', error);
      }
      });
      
    });
  }
  public async updateConfig(id:number,config: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
   
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/user/config/'+ id, config, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
      });
      
    });
  }
  public async postTrainng(training: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = training;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/user/training', body, {headers})
      .subscribe({
      next: (result:any) => {
        console.log('result: ', result);
        resolve(result);
      }
    ,error: (error:any) => {
      reject(error);
      console.log('error: ', error);
    }
    });
    });
  }
  public async getTeamEvents(team_id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/formation/teamevents/'+ team_id , {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async postTeamEvent(event: any): Promise<Observable<any>> {  
    return new Promise(async (resolve, reject) => {
      const body = event;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/formation/event', body, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async updateTeamEvent(id:number,event: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = event;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/formation/event/'+ id, body, {headers})
        .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
      
    });
  }
  
  public async deleteTeamEvent(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/formation/event/'+ id, {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          // console.log('error: ', error);
        }
      }); 
    }); 
  }
  public async getFormations(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/formation/formation', {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }

  public async addTempPlayer2team(player: any): Promise<Observable<any>> {
  return new Promise(async (resolve, reject) => {
    const body = player;
    const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
    this.http.post(SERVER + '/team/tempplayer', body, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
    });
  });
  }
  public async delTempPlayerFromTeam(player_id:number ): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/user/team/player/' + player_id, {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async saveLineup(event: any, id?:number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      let body = event;
      // console.log('saveEvent: ', body);
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      if(!id){
      this.http.post(SERVER + '/formation/event' , body, {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
        });
      }
      else{
        // delete body.id;
        // delete body.team_id;
        this.http.put(SERVER + '/formation/event/' + id, body, {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
        });
      }
    });

  }

  public async getMyMessages(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/message/user', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
    public async getMyCreatedMessages(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/message/my', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async getTeamMessages(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/message/team', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
    public async getClubMessages(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/message/club', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
  public async postUserMessage(user_id:number,messageObj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = messageObj;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/message/user/'+user_id, body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
      });
    });
  }
    public async postUserListMessage(messageObj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = messageObj;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/message/list/user', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);
      }
      });
    });
  }
  public async postTeamMessage(team_id:number,messageObj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = messageObj;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/message/team/'+team_id, body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);  
      }
      });
    });
  }
  public async postClubMessage(club_id:number,messageObj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = messageObj;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/message/club/'+club_id, body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);  
      }
      });
    });
  }
    public async postAllMessage(messageObj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = messageObj;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.post(SERVER + '/message/all/', body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);  
      }
      });
    });
  }
    public async putMessage(id:number,messageObj: any): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const body = messageObj;
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.put(SERVER + '/message/message/'+id, body, {headers})
      .subscribe({
      next: (result:any) => {
        resolve(result);
      }
      ,error: (error:any) => {
        reject(error);
        console.log('error: ', error);  
      }
      });
    });
  }
  public async deleteMessage(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.delete(SERVER + '/message/message/' + id, {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          // console.log('error: ', error);
        }
      }); 
    }); 
  }
   public async getAuthMessages(obj:{email:string,password:string }): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      if(!obj || !obj.email || !obj.password){
        reject('Invalid data');
        return;
      }
      const headers = {'Content-Type': 'application/json'};//,'Authorization': 'Bearer ' + this.storage.token  };
      this.http.post<any>(SERVER + '/message/messages/', obj, {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }
    public async getMyMessage(id: number): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/message/user/', {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          // console.log('error: ', error);
        }
      }); 
    }); 
  }
      public async getMyOldMessage(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      const headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + this.storage.token};
      this.http.get(SERVER + '/message/old/user/', {headers})
        .subscribe({
          next: (result:any) => {
            resolve(result);
          }
        ,error: (error:any) => {
          reject(error);
          // console.log('error: ', error);
        }
      }); 
    }); 
  }
  public async getStartupInfo(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
        // const headers = new HttpHeaders();
        // headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin' , '*');
        // headers.append('Connection', 'keep-alive');
        // headers.append('Keep-Alive', 'timeout=5');
      const headers = {'Content-Type': 'application/json'  };
      this.http.get<any>(SERVER + '/user/info/', {headers})
      .subscribe({
        next: (result:any) => {
          resolve(result);
        }
        ,error: (error:any) => {
          reject(error);
          console.log('error: ', error);
        }
      });
    });
  }

}
